import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import "ag-grid-enterprise";
import { getAuthProps } from '../../utils/AuthenticationLibrary';
import DailyReportsServices from '../../services/axiosServices/apiServices/DailyReportsServices';
import SwalServices from '../../services/swalServices/SwalServices';

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

class ItemGroupStockCategoryWiseDetailsReport extends Component {
    constructor(props) {
        super(props);
        this.dailyReportsServices = new DailyReportsServices();
        this.SwalServices = new SwalServices();
        this.state = {
            isTable2Expanded: false,
            isTable3Expanded: false,
            t1RowData: [
                // { item_grp: "Electronics", store_qty: 120 },
                // { item_grp: "Hardware", store_qty: 250 },
                // { item_grp: "Software", store_qty: 75 },
                // { item_grp: "Tools", store_qty: 180 },
                // { item_grp: "Furniture", store_qty: 90 },
            ],
            t1ColDefs: [
                {
                    field: "itemGroup",
                    headerName: "Item grp",
                    filter: true,
                    floatingFilter: true,
                    flex: 1,
                },
                {
                    field: "storeQty",
                    headerName: "Store qty",
                    filter: true,
                    floatingFilter: true,
                    flex: 1,
                },
            ],
            t2RowData: [],
            t2ColDefs: [
                {
                    field: "itemCategory",
                    headerName: "Item category",
                    filter: true,
                    floatingFilter: true,
                    flex: 1,
                },
                {
                    field: "storeQty",
                    headerName: "Store qty",
                    filter: true,
                    floatingFilter: true,
                    flex: 1,
                },
            ],

            t3RowData: [
                // {
                //     item_category: "Electronics",
                //     store_qty: 200,
                // },                
            ],
            t3ColDefs: [
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    filter: true,
                    floatingFilter: true,
                    minWidth: window.innerWidth * 0.1,
                    flex: 1,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    filter: true,
                    floatingFilter: true,
                    minWidth: window.innerWidth * 0.23,
                    flex: 2.3,
                },
                {
                    field: "storeQty",
                    headerName: "Store Qty",
                    filter: true,
                    floatingFilter: true,
                    minWidth: window.innerWidth * 0.1,
                    flex: 1,
                },
            ],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idItemGroup: 0,
        };
    }

    handleCellClick1 = (event) => {
        //debugger
        this.procItemStockRegister_ItemGroupWise(event.data.idItemGroup);
    };

    handleCellClick2 = (event) => {
        this.procItemStockRegisterTracking_ByItemCategory(event.data.idItemCategory);
    };

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany }, () => {
                this.procItemStockRegister_GroupWise_Dashboard();
            });
        } else {
            //window.location.href = "/Login";
        }
        window.addEventListener("resize", this.handleResize);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    procItemStockRegister_GroupWise_Dashboard = () => {
        // let request = {
        //     idCompany: this.state.idCompany,
        //     fromDate: this.state.requestDetails.fromDate,
        //     toDate: this.state.requestDetails.toDate
        // };
        let idCompany = this.state.idCompany;
        // debugger;
        this.dailyReportsServices.procItemStockRegister_GroupWise_Dashboard(idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let data = response.responseItem.responseContent;
                this.setState({ t1RowData: data }, () => {
                    //let data = this.state.userDetails;
                    //data.databaseName = databasename;
                    //this.setState({ rowData: data })
                    //this.goToNextStep()
                });
            }
        });
    }

    procItemStockRegister_ItemGroupWise = (idItemGroup) => {
        //let id1 = this.state.idCompany;
        //let id2 = idItemGroup; //this.state.idItemGroup;
        let request = {
            idCompany: this.state.idCompany,
            idItemGroup: idItemGroup
        };
        this.dailyReportsServices.procItemStockRegister_ItemGroupWise(request).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let data = response.responseItem.responseContent;
                this.setState({ t2RowData: data }, () => {
                    //let data = this.state.userDetails;
                    //data.databaseName = databasename;
                    //this.setState({ rowData: data })
                    //this.goToNextStep()
                });
            }
        });
    }

    procItemStockRegisterTracking_ByItemCategory = (idItemCategory) => {
        //let id2 = this.state.idItemGroup;
        //let request = [id1, id2];
        this.dailyReportsServices.procItemStockRegisterTracking_ByItemCategory(idItemCategory).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                //debugger;
                let data = response.responseItem.responseContent;
                this.setState({ t3RowData: data }, () => {
                    //let data = this.state.userDetails;
                    //data.databaseName = databasename;
                    //this.setState({ rowData: data })
                    //this.goToNextStep()
                });
            }
        });
    }


    render() {
        return (
            <div>
                <div className='item-group-stock-category-wise-details-report'>
                    <div className="data-display">
                        <div className="data-display-inner">
                            <div className="tables cursor-default w-full flex gap-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className="table-1 h-[50vh] w-full px-[1px] rounded-[5px]">
                                    <div className="table-inner">
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Group wise stock register</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.t1RowData} // Pass row data
                                        rowHeight={this.state.rowHeight}
                                        columnDefs={this.state.t1ColDefs} // Pass column definitions
                                        pagination={true} // Enable pagination
                                        paginationPageSize={this.state.paginationPageSize}
                                        rowSelection={this.rowSelection}
                                        onCellClicked={this.handleCellClick1}
                                    />
                                </div>
                                <div className="table-2 cursor-default h-[50vh] w-full px-[1px] rounded-[5px]">
                                    <div className="table-inner">
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Category wise stock register</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.t2RowData} // Pass row data
                                        rowHeight={this.state.rowHeight}
                                        columnDefs={this.state.t2ColDefs} // Pass column definitions
                                        pagination={true} // Enable pagination
                                        paginationPageSize={this.state.paginationPageSize}
                                        rowSelection={this.rowSelection}
                                        onCellClicked={this.handleCellClick2}
                                    />
                                </div>
                            </div>
                            <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] mt-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className="table-3 h-[50vh] w-full px-[1px] rounded-[5px]">
                                    <div className="table-inner">
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Item stock details</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.t3RowData} // Pass row data
                                        rowHeight={this.state.rowHeight}
                                        columnDefs={this.state.t3ColDefs} // Pass column definitions
                                        pagination={true} // Enable pagination
                                        paginationPageSize={this.state.paginationPageSize}
                                        rowSelection={this.rowSelection}
                                    //onCellClicked={this.handleCellClick3}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ItemGroupStockCategoryWiseDetailsReport;